import React from 'react';
import { Button } from '@prio365/prio365-react-library';
import { useTranslation } from 'react-i18next';
import { DashboardItem } from '../../../models/Dashboard';

interface WidgetActionsProps {
  item: DashboardItem;
  onExpand: (item: DashboardItem) => void;
  onRemove: (id: string) => void;
  onEdit?: () => void;
  isExpandable?: boolean;
  isNotDeletable?: boolean;
  isEditable?: boolean;
}

const WidgetActions: React.FC<WidgetActionsProps> = ({
  item,
  onExpand,
  onRemove,
  onEdit,
  isExpandable = false,
  isNotDeletable = false,
  isEditable = false,
}) => {
  const { t } = useTranslation();

  const handleExpand = (e: React.MouseEvent) => {
    e.stopPropagation();
    onExpand(item);
  };

  return (
    <>
      {isEditable && (
        <Button iconProp={['fal', 'pen']} onClick={onEdit}>
          {t('dashboard:widgets.edit')}
        </Button>
      )}
      {isExpandable && (
        <Button iconProp={['fal', 'expand']} onClick={handleExpand}>
          {t('dashboard:widgets.expand')}
        </Button>
      )}
      {!isNotDeletable && (
        <Button
          iconProp={['fal', 'trash']}
          onClick={() => onRemove(item.dashboardItemId)}
        >
          {t('dashboard:widgets.remove')}
        </Button>
      )}
    </>
  );
};

export default WidgetActions;
